import { addClass, removeClass } from "../util/misc";

export default {
  init() {
    // changeTabs();
    // showFullExcerpt();
  },
  finalize() {},
};

export const changeTabs = () => {
  const products = document.querySelectorAll(".products");
  const tabItems = document.querySelectorAll(".tabButton");

  if (!tabItems) return;

  tabItems.forEach((item, index) => {
    _activateFirstElement(item, index);

    // onclick action
    item.addEventListener("click", () => {
      _setActiveTab(item);
      _filterProducts(products, item.dataset.category);
    });
  });
};

const bgClass = "bg-primary";

const _activateFirstElement = (item, index) => {
  if (index !== 0) return;
  const theTab = item.parentNode.querySelector(".currentTabLine");
  addClass(theTab, bgClass);
};

const _setActiveTab = (item) => {
  _removeActiveTabLine();
  _setNewActiveTab(item);
};

const _removeActiveTabLine = () => {
  const tabLines = document.querySelectorAll(".currentTabLine");
  tabLines.forEach((item) => {
    removeClass(item, bgClass);
  });
};

const _setNewActiveTab = (item) => {
  const theTab = item.parentNode.querySelector(".currentTabLine");
  addClass(theTab, bgClass);
};

const _filterProducts = (products, selectedCategory) => {
  if (products.length < 1) return;
  products.forEach((item) => {
    addClass(item, "hidden");
    removeClass(item, "block");

    const data = item.dataset.categories;
    if (data == selectedCategory) {
      addClass(item, "block");
      removeClass(item, "hidden");
    } else if (selectedCategory == "all") {
      removeClass(item, "hidden");
      addClass(item, "block");
    }
  });
  // console.log(products);
};

// show full excerpt
export const showFullExcerpt = () => {
  const innerDesign = document.querySelectorAll(".innerDesign");
  if (innerDesign.length < 1) return;
  innerDesign.forEach((item) => {
    const excerpt = item.querySelector(".productExcerpt");
    item.addEventListener("mouseover", () => _showExcerpt(item, excerpt));
    item.addEventListener("mouseout", () => _hideExcerpt(item, excerpt));
  });
};

const _showExcerpt = (innerDesign, excerpt) => {
  removeClass(innerDesign, "h-56%");
  addClass(innerDesign, "bg-secondaryTinted");
  addClass(innerDesign, "h-full");

  // expand excerpt
  removeClass(excerpt, "line-clamp");
};

const _hideExcerpt = (innerDesign, excerpt) => {
  addClass(innerDesign, "h-56%");
  removeClass(innerDesign, "h-full");
  removeClass(innerDesign, "bg-secondaryTinted");

  // expand excerpt
  addClass(excerpt, "line-clamp");
};



// WEBPACK FOOTER //
// ./scripts/sections/products.js